import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { GetVodafoneTemlikRequest, GetVodafoneTemlikResponse } from '../models/model'

export class GetTemlikSummaryListApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'VodafoneReports/GetVodafoneTemlikSummaryList',
      requesterInfo,
    })
  }

  public async getSummaryList(request: GetVodafoneTemlikRequest): Promise<GetVodafoneTemlikResponse[]> {
    return await this.postAsync<GetVodafoneTemlikResponse[]>(request)
  }
}